const PHONE = '(844) 787-2847';

export const APP = {
  CLOSE: 'Close',
  DOWNLOAD_PDF: 'Download PDF Version',
  HERO: 'How can we help?',
  HOME_NAV: 'Home',
  LAST_UPDATED: 'Last Updated',
  LEARN_MORE: 'Click here to learn more',
  NO_RESULTS_FOUND: 'No Articles Found',
  OTHER_WAYS: 'Other ways we can help',
  SCROLL_TOP: 'Scroll to Top',
  SEARCH: 'Search for answers',
  TABLE_OF_CONTENTS: 'Table of Contents',
  TAGLINE: 'Help Site',
  TITLE: 'STRATIS',
  TRY_AGAIN: 'Try searching something else',
  VIEW_MORE: 'View More',
};

export const ADDRESS = `RealPage, Inc. Richardson, TX 75082 <a href="tel:${PHONE}">${PHONE}</a> Option 2`;
export const COPYRIGHT = '&copy; Copyright 1998-2019 All rights reserved';

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/STRATISIoT',
  // https://www.facebook.com/realpage
  linkedIn: 'https://www.linkedin.com/company/stratis-iot',
  // https://twitter.com/RealPage
  twitter: 'https://twitter.com/STRATISIoT', // https://www.linkedin.com/company/realpage
  youtube: 'https://www.youtube.com/channel/UCHxCZOGqGUmKmQDt8-NbWEA', // https://www.youtube.com/user/RealPageMedia
};

export const FOOTER_LINKS = [
  {
    href: 'https://stratisiot.com/stratis-terms-service',
    text: 'Terms of Service',
  },
  {
    href: 'https://stratisiot.com/privacy-policy',
    text: 'Privacy Policy',
  },
  {
    href: 'https://stratisiot.com/stratis-mobile-app-end-user-license-agreement',
    text: 'EULA Agreement',
  },
];

export const showingResults = (
  start: string,
  totalCount: string,
  searchTerm: string
) => `Showing ${start} of ${totalCount} for <em>&quot;${searchTerm}&quot;</em>`;
